var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackSiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-site"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "site",
    clipPath: "url(#clip-site)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33574",
    "data-name": "Group 33574",
    transform: "translate(-2.501 -5.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Artboard_1",
    "data-name": "Artboard 1",
    d: "M34.6,2.157A1.573,1.573,0,0,0,32.552.113L26.445,2.555A17.552,17.552,0,0,0,17.3,0a17.194,17.194,0,0,0-9.44,2.822l0,0a17.266,17.266,0,0,0,0,28.964h0A17.191,17.191,0,0,0,17.3,34.6,17.409,17.409,0,0,0,34.709,17.3a17.2,17.2,0,0,0-2.554-9.038Z",
    transform: "matrix(-0.695, 0.719, -0.719, -0.695, 49.003, 24.038)",
    fill: "#434343",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Artboard_1-2",
    "data-name": "Artboard 1",
    d: "M73.5,38.14h6.242v5.109h2.246v9.622H72.37V38.14Zm6.221,7.377H74.637V50.6h5.088Zm-2.246-5.109H74.637V43.25h2.841Z",
    transform: "translate(-52.319 -20.54)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSiteIcon);
export default __webpack_public_path__ + "static/media/black-site-icon.15429d88f236c57bf1badd0d006ea911.svg";
export { ForwardRef as ReactComponent };